module.exports = __webpack_public_path__ + "static/media/service_system_10.659604fe.png";